import { fetchParagraphs } from '@services/paragraphsService';
import {
  buildTimestamp,
  containsReplacementChar,
  downloadTextFile,
  parseCsvFileWithEncodingFallback,
  unparseCsvWithBom,
} from '../../shared/csvUtils';
import { parseLocale, parsePopulation } from '../../shared/csvParsing';

// -----------------------
// Import (parse)
// -----------------------
const REQUIRED_HEADERS = ['text'];

const parseRow = (row, rowNumber) => {
  const text = String(row?.text ?? '').trim();
  if (!text) return { error: `Row ${rowNumber}: missing text` };

  try {
    const value = {
      text,
      locale: parseLocale(row?.locale),
      population: parsePopulation(row?.population),
    };
    return { value };
  } catch (e) {
    return { error: `Row ${rowNumber}: ${e.message}` };
  }
};

export function parseParagraphsCSV(file) {
  return parseCsvFileWithEncodingFallback({
    file,
    requiredHeaders: REQUIRED_HEADERS,
    parseRow,
    shouldRetryWithNextEncoding: (items) => (items || []).some((i) => containsReplacementChar(i?.text)),
  });
}

// -----------------------
// Export (download)
// -----------------------

// buildTimestamp + downloadTextFile are shared in csvUtils

export async function exportParagraphsCSV() {
  const all = await fetchParagraphs();
  if (!all?.length) {
    throw new Error('No paragraphs to export');
  }

  const rows = all.map((p) => ({
    text: p?.text ?? '',
    locale: p?.locale ?? '',
    population: Array.isArray(p?.population) ? p.population.join(',') : '',
    wordCount: typeof p?.wordCount === 'number' ? p.wordCount : '',
  }));

  const csv = unparseCsvWithBom({
    rows,
    columns: ['text', 'locale', 'population', 'wordCount'],
  });
  const filename = `novotalk_paragraphs_${buildTimestamp()}.csv`;
  downloadTextFile({ content: csv, filename, mimeType: 'text/csv;charset=utf-8;' });

  return { filename, count: rows.length };
}
